export default "__VITE_PUBLIC_ASSET__30b0edf3__"